import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, FileText, Film, Download } from 'lucide-react';

const items = [
  { icon: BookOpen, type: 'Blog',         title: 'Insights & thinking', desc: 'Articles on delivery governance, NHS capital, FM assurance and AI in delivery.', placeholder: '6 posts coming soon' },
  { icon: FileText, type: 'Case studies', title: 'In the field',         desc: 'Real-world deployments across NHS, FM and construction.', placeholder: '3 studies coming soon' },
  { icon: Film,     type: 'Video library',title: 'Watch the platform',   desc: 'Full Synthesia suite — hero, capabilities, integrations, sectors.', placeholder: '7 videos in production' },
  { icon: Download, type: 'Brochure',     title: 'Download',             desc: 'Videra launch brochure — the operating system for delivery.', placeholder: 'PDF · coming soon' },
];

const V2Resources = () => (
  <div data-testid="v2-resources">
    <section className="pt-20 pb-16 md:pt-28 md:pb-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs uppercase tracking-[0.2em] text-blue-600 font-semibold mb-4">Resources</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight text-slate-900 leading-[1.05] max-w-4xl">
          Read. Watch. Download.
        </h1>
        <p className="mt-8 text-lg lg:text-xl text-slate-600 leading-relaxed max-w-3xl">
          A library of thinking, case studies, videos and downloads — built around how Videra delivers
          governance, assurance and intelligence to projects and assets.
        </p>
      </div>
    </section>

    <section className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {items.map((it) => (
            <div key={it.type} className="bg-white border border-slate-200 rounded-2xl p-8 hover:border-slate-900 transition-all" data-testid={`v2-resource-${it.type.toLowerCase().replaceAll(' ','-')}`}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-slate-900 flex items-center justify-center">
                  <it.icon className="w-5 h-5 text-white" />
                </div>
                <p className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">{it.type}</p>
              </div>
              <h3 className="text-xl font-medium text-slate-900 mb-2">{it.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed mb-6">{it.desc}</p>
              <div className="aspect-[16/7] bg-gradient-to-br from-slate-100 to-slate-50 rounded-lg border border-dashed border-slate-300 flex items-center justify-center">
                <p className="text-xs text-slate-400 italic">{it.placeholder}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="py-24 md:py-32 bg-slate-950 text-white text-center">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight">
          Want to be the first to know?
        </h2>
        <p className="mt-6 text-lg text-slate-400">
          Subscribe for releases, case studies and the latest from the Videra platform.
        </p>
        <Link to="/contact" className="inline-flex items-center justify-center bg-white text-slate-900 px-8 py-4 font-medium tracking-wide hover:bg-slate-100 transition-all mt-10 rounded-md">
          Get in touch
        </Link>
      </div>
    </section>
  </div>
);

export default V2Resources;
